// 实验任务详情缓存（持久化到 localStorage）

// 定义存储在 localStorage 中的键名，用于标识这个缓存数据，避免与其他存储内容冲突
const STORAGE_KEY = 'experimentTask.taskIdToDetail';

// 从 localStorage 加载缓存数据
function loadPersistedMap() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (e) {
    console.error('加载 experimentTask 缓存失败:', e);
    return {};
  }
}

// 将数据保存到 localStorage
function persistMap(map) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map || {}));
  } catch (e) {
    console.error('持久化 experimentTask 缓存失败:', e);
  }
}

const state = {
  // 以 taskId 为 key 的任务详情缓存
  taskIdToDetail: loadPersistedMap(),
};

// 同步修改状态 定义修改状态的方法
const mutations = {
  // 设置任务详情
  setTaskDetail(state, payload) {
    const { taskId, detail } = payload || {};
    if (!taskId) return;
    // 创建新对象，避免直接修改原对象（保持状态不可变性）
    state.taskIdToDetail = { ...(state.taskIdToDetail || {}), [taskId]: detail };
    // 同步到本地存储
    persistMap(state.taskIdToDetail);
  },
  // 清除单个任务详情
  clearTaskDetail(state, taskId) {
    if (!taskId) return;
    // 复制当前对象
    const next = { ...(state.taskIdToDetail || {}) };
    // 删除指定任务
    delete next[taskId];
    // 更新状态
    state.taskIdToDetail = next;
    // 同步到本地存储
    persistMap(state.taskIdToDetail);
  },
  // 清除所有任务详情
  clearAll(state) {
    // 清空状态
    state.taskIdToDetail = {};
    // 同步到本地存储
    persistMap(state.taskIdToDetail);
  },
};

// 包含异步操作 用于调用 mutations，用于处理异步逻辑，这里主要是对 mutations 做了一层封装
const actions = {
  // 缓存任务详情
  cacheTaskDetail({ commit }, { taskId, detail }) {
    commit('setTaskDetail', { taskId, detail });
  },
  // 移除单个任务详情
  removeTaskDetail({ commit }, taskId) {
    commit('clearTaskDetail', taskId);
  },
  // 清除所有缓存
  clearAll({ commit }) {
    commit('clearAll');
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};


